(function ($) {
  Drupal.behaviors.customerServiceQAPageSectionRowV1 = {
    attach: function (context, settings) {
      var formatter = $('.cs-qa-page-section-row-v1');
      var questionCollections = [];

      formatter.each(function (i) {
        var thisFormatter = $(this);
        var foundMatch = false;

        jQuery.each(questionCollections, function (i, v) {
          if (v.container === thisFormatter.parent().get(0)) {
            v.questions = v.questions.add(thisFormatter.get(0));
            foundMatch = true;

            return false;
          }
        });
        if (!foundMatch) {
          questionCollections.push({
            container: thisFormatter.parent().get(0),
            questions: $(thisFormatter.get(0)) // building a new jQuery object, instead of using the current one (i.e., thisFormatter)
          });
        }
      });

      jQuery.each(questionCollections, function (i, v) {
        v.questions.each(function (i) {
          var thisFormatter = $(this);

          // Add item-x class to thisFormatter and its row     
          thisFormatter.addClass('item-' + i).find('.row').addClass('item-' + i);

          // Highlight first question
          var firstQuestionItem = thisFormatter.find('.row.item-0').find('.question-col').find('.question');

          firstQuestionItem.addClass('active');

          // Find first answer text
          var firstItem = thisFormatter.find('.row.item-0').find('.answer-col').find('.answer'),

            // Assign first answer to default item
            defaultMsg = firstItem.html(),

            // This will be used to set the height bellow
            parent = thisFormatter.parent(),

            // Get parent position
            // position = parent.position(),

            // Set top position to be used by active answer section
            // Now we're using a div wrapper (.cs-page-section) around "thisFormatter" set to "position: relative" to get the top position from it which is "0"
            top = '0',

            // Set height to be used by active answer section
            height = '100',
            ext = '%'; // change to whatever unit is used, e.g.: 'px', 'em', '%'

          // Display default answer on page load
          if (i === 0) {
          // Inject first answer into the default answer
            thisFormatter.parent()
              .css({ 'position': 'relative' })
              .append('<div class="cs-qa-page-section-row-v1 item-' + i + '"><div class="row"><div style="top:' + top + 'px; height:' + height + ext + ';" class="answer-col default"><div class="answer">' + defaultMsg + '</div></div></div></div>')
              .show();
          }

          // Get each question's answer on click
          thisFormatter.find('.row').find('.question-col').find('.question').once().on('click', function() {
            var question = $(this);

            // Set question to "active" on click
            question.toggleClass('active');

            // Hide default answer when clicking on another question
            thisFormatter.parent().find('.answer-col.default').hide();

            // Remove 'active' class from 'this' siblings
            thisFormatter.siblings().find('.row').find('.question-col').find('.question').removeClass('active');

            // Show 'this' question's answer and set its height and position
            question.parent().next().show().css({
              'position': 'absolute',
              'top': top + 'px',
              'right': '0',
              'height': height + ext
            }).find('.answer').css({
              'overflow': 'visible',
              'height': height + ext
            });

            // Hide other non-active answers
            thisFormatter.siblings().find('.row').find('.answer-col').hide();

            // Set answer max-height
            thisFormatter.siblings().find('.row').find('.answer-col').find('.answer').css({ 'max-height': height + ext });
          });
        });
      });
    }
  };
})(jQuery);
